export const RESTRICTION_LAYER_ID = "restriction" as const
export const TFR_LAYER_ID = "tfr" as const
export const NOTAM_LAYER_ID = "notam" as const
export const AIRSPACE_LAYER_IDS = [RESTRICTION_LAYER_ID, TFR_LAYER_ID, NOTAM_LAYER_ID]
